import { makeStyles } from 'tss-react/mui';
import React, { useCallback } from 'react';
import Button from '@ui/Button';
import { PrimaryButtonProps } from '@ui/Button/legacy/PrimaryButton';
import LoadingIcon from '../LoadingIndicators/CircularLoader';

interface PreviewButtonProps extends PrimaryButtonProps {
  isSave: boolean;

  onSubmit: () => void;
}

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()(theme => ({
  button: {
    padding: theme.spacing(1, 2),
    minWidth: theme.spacing(14.625),
  },
  label: {
    fontWeight: 'bold',
  },
  loadingIcon: {
    width: `${theme.spacing(2)} !important`,
    height: `${theme.spacing(2)} !important`,
    marginRight: theme.spacing(1),
  },
  loadingIconSpinner: {
    color: theme.palette.common.black,
  },
}));

const PreviewButton = (props: PreviewButtonProps) => {
  const { disabled, loading, isSave, onSubmit } = props;
  const { classes } = useStyles();

  const handleClick = useCallback(() => {
    onSubmit();
  }, [onSubmit]);

  const savingLabel = loading && isSave && 'saving';
  const loadingLabel = loading && 'loading';
  const defaultLabel = 'preview clip';
  const saveLabel = isSave && 'save clip';

  const buttonLabelText =
    savingLabel || loadingLabel || saveLabel || defaultLabel;

  return (
    <Button
      variant="primary"
      aria-label="Preview clip"
      onClick={handleClick}
      size={'small'}
      color={'primary'}
      className={classes.button}
      disabled={disabled}
    >
      {loading ? (
        <LoadingIcon
          className={classes.loadingIcon}
          classes={{ circle: classes.loadingIconSpinner }}
        />
      ) : undefined}
      {buttonLabelText}
    </Button>
  );
};

export default PreviewButton;
